export default __webpack_public_path__ + "static/media/COSTAL25.62b63495.png";